<mat-card class="card-section">
  <mat-card-header>
    <mat-card-title>Routing Rules</mat-card-title>
    <button mat-raised-button (click)="this.addRule.emit()">
      <mat-icon>add</mat-icon>
      Add Rule
    </button>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let rule of routingRules">
        <div class="list-item-content">
          <h3 matLine>{{ rule.paymentMethod | titlecase }} Rule</h3>
          <p matLine>
            Priority: {{ rule.priority }} → {{ rule.provider }} (<code class="">{{
              rule.targetPaypoint | paypointCode
            }}</code
            >)
          </p>
        </div>
        <div class="list-item-actions">
          <button mat-icon-button color="warn" (click)="onDeleteRule(rule)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
